<bootstrap-popup [id]="id" [title]="'Signer le pdp et ajouter des signataires'" [displaySubject]="displaySubject" [modalSize]="'modal-xl'" [windowCloseButton]="true">
<div class="valideurs">
    <pannel [title]="'Valideurs'" [expandable]="true" >
    	<div class="col-sm-12 action-tableau">
    		<div class="col-sm-2 bouton-ajout">
        		<button type="button" class="btn btn-primary" (click)="addValideur()">Ajouter un Valideur</button>
        	</div>
	        <div class="col-sm-2 liste-entreprises">
		        <select class="form-control entreprise-filter" [(ngModel)]="selectedEntrepriseForValideurDialog">
		            <option [ngValue]="null"></option>
		            <option *ngFor="let entrepriseTLR of entreprises" [ngValue]="entrepriseTLR">{{entrepriseTLR.nom}}</option>
		        </select>
	        </div>
	        <div class="col-sm-8"></div>
        </div>
        <table class="validateurs-table" *ngIf="valideursDuPdp.length > 0">
	       	<th>Nom / Prénom</th>
	       	<th>Email</th>
	       	<th>Représentant / Intervenant ?</th>
	       	<th class="cb-header">Enveloppe Docusign</th>
	       	<th class="cb-header">Signer</th>
	       	<tbody>
	       	<tr class="global-operations">
				<td colspan="3">
					Tous cocher
				</td>
				<td class="envelope-cb">
					<mat-checkbox [disabled]="pdp.obsolete || pdp.expired" [(ngModel)]="sendAllValideursCb" color="primary" (change)="onCheckSendAllValideurs($event)"></mat-checkbox>
				</td>
				<td class="sign-cb">
					<mat-checkbox [(ngModel)]="signAllValideursCb" color="primary" (change)="onCheckSignAllValideurs($event)"></mat-checkbox>
				</td>
			</tr>
			<ng-container *ngFor="let valideur of valideursDuPdp; let index = index">
				<tr class="entreprise-break" *ngIf="index === 0 || valideursDuPdp[index].intervenantEntrepriseId != valideursDuPdp[index-1].intervenantEntrepriseId">
					<td colspan="3">
						{{ valideursDuPdp[index].intervenantEntrepriseNom }}
					</td>
					<td class="entreprise-envelope-cb">
						<mat-checkbox [(ngModel)]="sendAllValideursInEntrepriseCb[valideursDuPdp[index].intervenantEntrepriseId]"
						 	[disabled]="pdp.obsolete || pdp.expired" color="primary" 
							(change)="onCheckSendAllValideursInEntreprise($event, valideursDuPdp[index].intervenantEntrepriseId)">
						</mat-checkbox>
						<i class="fa fa-eye" aria-hidden="true"><span>x</span></i>
					</td>
					<td>&nbsp;</td>
				</tr>
				<tr>
					<td>{{ valideur.nom }} {{ valideur.prenom }}</td>
					<td>
						<input id="emailValideur" name="emailValideur" class="form-control {{ valideur.emailStyle }}" [disabled]="!valideur.updatable" 
						[(ngModel)]="valideur.email" (focusout)="onFocusLeaveEmailValideur(valideur)" >
					</td>
					<td>
				        <select class="form-control" [ngClass]="'form-control'" [(ngModel)]="valideur.typeValideur" 
				        	(change)="onChangeTypeValideur(index)" [attr.disabled]="!valideur.updatable ? true : null" >
				            <option [ngValue]="null" disabled></option>
				            <option *ngFor="let typeValideur of suggestableTypeValideurs(valideur)" [ngValue]="typeValideur.code" >
				            	{{ typeValideur.label }}
				            </option>
				        </select>
					</td>
					<td class="cb-docusign">
						<mat-checkbox [(ngModel)]="valideur.sentToDocusign" color="primary" 
							[disabled]="!valideur.updatable || !valideur.email || valideur.emailStyle === 'error'"
							(change)="refreshValideursSendCbs(); checkIfShouldDocusign()">
						</mat-checkbox>
						<i class="fa fa-eye {{ valideur.docusignEnvelopeId && valideur.envelopeIndex > -1 ? '' : 'invisible' }} " (click)="viewEnveloppeDetail(valideur.docusignEnvelopeId)">
							<span class="numero-envelope">{{ valideur.docusignEnvelopeId && valideur.envelopeIndex ? valideur.envelopeIndex : 'x' }}</span>
						</i>
					</td>
					<td>
						<mat-checkbox [(ngModel)]="valideur.hasSigned" color="primary" 
							[disabled]="valideur.hasSignedEnvelope"
							(change)="refreshValideursSignCbs()"></mat-checkbox>
					</td>
				</tr>
			</ng-container>
			</tbody>
        </table>
    </pannel>
</div>

<div class="representants">
    <pannel [title]="'Représentants'" [expandable]="true" >
    	<div class="col-sm-12 action-tableau">
    		<div class="col-sm-2 bouton-ajout">
        		<button type="button" class="btn btn-primary" (click)="addRepresentant()">Ajouter un représentant</button>
        	</div>
	        <div class="col-sm-2 liste-entreprises">
		        <select class="form-control entreprise-filter" [(ngModel)]="selectedEntrepriseForRepresentantDialog">
		            <option [ngValue]="null"></option>
		            <option *ngFor="let entrepriseTLR of entreprises" [ngValue]="entrepriseTLR">{{entrepriseTLR.nom}}</option>
		        </select>
	        </div>
	        <div class="col-sm-8"></div>
        </div>
        <table class="representants-table" *ngIf="representantsDuPdp.length > 0">
	       	<th>Nom / Prénom</th>
	       	<th>Email</th>
	       	<th class="cb-header">Représentant / Intervenant ?</th>
	       	<th class="cb-header">Enveloppe Docusign</th>
	       	<th class="cb-header">Signer</th>
	       	<tbody>
	       	<tr class="global-operations">
				<td colspan="3">
					Tous cocher
				</td>
				<td class="envelope-cb">
					<mat-checkbox [(ngModel)]="sendAllRepresentantsCb" color="primary" 
						[disabled]="pdp.obsolete || pdp.expired"  (change)="onCheckSendAllRepresentants($event)">
					</mat-checkbox>
				</td>
				<td class="sign-cb">
					<mat-checkbox [(ngModel)]="signAllRepresentantsCb" color="primary" (change)="onCheckSignAllRepresentants($event)"></mat-checkbox>
				</td>
			</tr>
			<ng-container *ngFor="let representant of representantsDuPdp; let index = index">
				<tr class="entreprise-break" *ngIf="index === 0 || representantsDuPdp[index].intervenantEntrepriseId != representantsDuPdp[index-1].intervenantEntrepriseId">
					<td colspan="3">
						{{ representantsDuPdp[index].intervenantEntrepriseNom }}
					</td>
					<td class="entreprise-envelope-cb">
						<mat-checkbox [(ngModel)]="sendAllRepresentantsInEntrepriseCb[representantsDuPdp[index].intervenantEntrepriseId]" 
							color="primary" [disabled]="pdp.obsolete || pdp.expired"  
							(change)="onCheckSendAllRepresentantsInEntreprise($event, representantsDuPdp[index].intervenantEntrepriseId)">
						</mat-checkbox>
						<i class="fa fa-eye" aria-hidden="true"><span>x</span></i>
					</td>
					<td>&nbsp;</td>
				</tr>
				<tr>
					<td>{{representant.intervenantNom }} {{representant.intervenantPrenom }}</td>
					<td>
						<input id="emailRepresentant" name="emailRepresentant" class="form-control {{ representant.emailStyle }}" 
							  [disabled]="!representant.updatable" [(ngModel)]="representant.email" 
							 (focusout)="onFocusLeaveEmailRepresentant(representant)" >
					</td>
					<td>
				        <mat-checkbox [(ngModel)]="representant.isIntervenant" color="primary" 
				        	[disabled]="!representant.updatable" (change)="onCheckRepresentantIntervenant(representant, index)">
			        	</mat-checkbox>
					</td>
					<td class="cb-docusign">
						<mat-checkbox [(ngModel)]="representant.sentToDocusign" color="primary" 
				        	[disabled]="!representant.updatable || !representant.email || representant.emailStyle === 'error'"
							(change)="refreshRepresentantsSendCbs(); checkIfShouldDocusign()" >
						</mat-checkbox>
						<i class="fa fa-eye {{ representant.docusignEnvelopeId && representant.envelopeIndex > -1 ? '' : 'invisible' }} " (click)="viewEnveloppeDetail(representant.docusignEnvelopeId)">
							<span class="numero-envelope">{{ representant.docusignEnvelopeId && representant.envelopeIndex ? representant.envelopeIndex : 'x' }}</span>
						</i>
					</td>
					<td>
						<mat-checkbox [(ngModel)]="representant.hasSigned" color="primary"
							[disabled]="representant.hasSignedEnvelope" (change)="refreshRepresentantsSignCbs(); checkSignIntervenantsSubalterne($event, representant)"
							></mat-checkbox>
					</td>
				</tr>
			</ng-container>
			</tbody>
        </table>
    </pannel>
</div>

<div class="intervenants">
    <pannel [title]="'Intervenants'" [expandable]="true" >
    	<div class="col-sm-12 action-tableau">
    		<div class="col-sm-2 bouton-ajout">
	        	<button type="button" class="btn btn-primary" (click)="addIntervenant()">Ajouter un intervenant</button>
        	</div>
	        <div class="col-sm-2 liste-entreprises">
		        <select class="form-control entreprise-filter" [(ngModel)]="selectedEntrepriseForIntervenantDialog">
		            <option [ngValue]="null"></option>
		            <option *ngFor="let entrepriseTLR of entreprises" [ngValue]="entrepriseTLR">{{entrepriseTLR.nom}}</option>
		        </select>
	        </div>
	        <div class="col-sm-8"></div>
        </div>
        <table class="intervenants-table" *ngIf="intervenantsDuPdp.length > 0">
	       	<th>Nom / Prénom</th>
	       	<th>Email</th>
	       	<th></th>
	       	<th class="cb-header">Enveloppe Docusign</th>
	       	<th class="cb-header">Signer</th>
	       	<tbody>
	       	<tr class="global-operations">
				<td colspan="3">
					Tous cocher
				</td>
				<td class="envelope-cb">
					<mat-checkbox [(ngModel)]="sendAllIntervenantsCb" color="primary" 
						[disabled]="pdp.obsolete || pdp.expired" (change)="onCheckSendAllIntervenants($event)">
					</mat-checkbox>
				</td>
				<td class="sign-cb">
					<mat-checkbox [(ngModel)]="signAllIntervenantsCb" color="primary" (change)="onCheckSignAllIntervenants($event)"></mat-checkbox>
				</td>
			</tr>
			<ng-container *ngFor="let intervenant of intervenantsDuPdp; let index = index">
				<tr class="entreprise-break" *ngIf="index === 0 || intervenantsDuPdp[index].idEntreprise != intervenantsDuPdp[index-1].idEntreprise">
					<td colspan="3">
						{{ intervenantsDuPdp[index].nomEntreprise }}
					</td>
					<td class="entreprise-envelope-cb">
						<mat-checkbox [(ngModel)]="sendAllIntervenantsInEntrepriseCb[intervenantsDuPdp[index].idEntreprise]" 
							color="primary" [disabled]="pdp.obsolete || pdp.expired" 
							(change)="onCheckSendAllIntervenantsInEntreprise($event, intervenantsDuPdp[index].idEntreprise)">
						</mat-checkbox>
						<i class="fa fa-eye" aria-hidden="true"><span>x</span></i>
					</td>
					<td>&nbsp;</td>
				</tr>
				<tr>
					<td>{{intervenant.nom }} {{intervenant.prenom }}</td>
					<td>
						<input id="emailIntervenant" name="emailIntervenant" class="form-control {{ intervenant.emailStyle }}" 
							[disabled]="!intervenant.updatable"  [(ngModel)]="intervenant.email" 
							(focusout)="onFocusLeaveEmailIntervenant(intervenant)" >
					</td>
					<td>&nbsp;</td>
					<td class="cb-docusign">
						<mat-checkbox [(ngModel)]="intervenant.sentToDocusign" color="primary" 
							title="{{ !intervenant.hasSignedEnvelope && intervenant.hasSigned ? 'Signé par le représentant' : '' }}"
							[disabled]="!intervenant.updatable || !intervenant.email || intervenant.emailStyle === 'error'"
							(change)="refreshIntervenantsSendCbs(); checkIfShouldDocusign()">
						</mat-checkbox>
						<i class="fa fa-eye {{ intervenant.envelopeId && intervenant.envelopeIndex > -1 ? '' : 'invisible' }} " (click)="viewEnveloppeDetail(intervenant.envelopeId)">
							<span class="numero-envelope">{{ intervenant.envelopeId && intervenant.envelopeIndex ? intervenant.envelopeIndex : 'x' }}</span>
						</i>
					</td>
					<td>
						<mat-checkbox [(ngModel)]="intervenant.hasSigned" color="primary" 
							[disabled]="intervenant.hasSignedEnvelope || hisRepresentantHasSigned(intervenant)" (change)="refreshIntervenantsSignCbs()" >
						</mat-checkbox>
					</td>
				</tr>
			</ng-container>
			</tbody>
        </table>
    </pannel>
</div>

<div class="row footer">
	<div class="col-md-12">
		<div class="form-group text-center">
			<button type="button" class="btn btn-success" style="margin-right: 10px" (click)="onCloseRequested()">
				Fermer
			</button>
			<button type="button" class="btn btn-primary" style="margin-right: 6px" (click)="onSaveRequested()" 
				title = "Sauvegarder" [disabled]="hasInvalidEmails() || waitingForServer" *ngIf="!hasAtLeastOneSigner" >
				Sauvegarder
			</button>
			<button type="button" class="btn btn-primary" style="margin-right: 6px" (click)="onSaveAndSendRequested()" 
				title = "{{ buttonInfo() }}" [disabled]="hasBlankOrInvalidEmails() || waitingForServer" *ngIf="hasAtLeastOneSigner" >
				Envoyer et Sauvegarder
			</button>
		</div>
	</div>
</div>

</bootstrap-popup>

<!-- popup gestion des valideurs -->
<signataire-dialog [id]="'gererValideursInPopupSignature'" [initCommands]="gererValideursCommands" (signatairesSelected)="onValideursSelected($event)"></signataire-dialog>

<!-- popup gestion des referents -->
<signataire-dialog [id]="'gererRepresentantsInPopupSignature'" [initCommands]="gererRepresentantsCommands" (signatairesSelected)="onRepresentantsSelected($event)"></signataire-dialog>

<!-- popup gestion des intervenants -->
<signataire-dialog [id]="'gererIntervenantsInPopupSignature'" [initCommands]="gererIntervenantsCommands" (signatairesSelected)="onIntervenantsSelected($event)"></signataire-dialog>

<!-- popup détail des envelopes -->
<docusign-enveloppe-dialog [id]="'docusignEnvelopeDialogForGeneralPdps'" [initCommands]="viewEnveloppeCommand" (onEnvelopeCancellation)="onEnvelopeCancellation()" >
